import { learningApi } from 'services/api'

export const RESET_PASSWORD = async (password: string, email: string, token: string) => {
  try {
    const result = await learningApi.patch('/student/auth/password/reset', {
      password,
      email,
      token,
    })

    return result
  } catch (err) {
    console.log(err)
    throw err
  }
}
